<template>
  <div class="heading">
    <CoinIcon class="icon-wrapper" :url="iconUrl" />
    <h2>{{name}}<small>({{symbol}})</small></h2>
  </div>
</template>

<script>
import CoinIcon from '@/components/coin/CoinIcon';

export default {
  name: 'CoinHeading',
  components: {
    CoinIcon,
  },
  props: [
    'name',
    'symbol',
    'iconUrl',
  ],
};
</script>

<style lang="scss" scoped>
.heading {
  margin: 1rem;
  text-align: center;

  .icon-wrapper {
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.25rem;
  }

  h2 {
    display: inline-block;
    vertical-align: middle;
    font-size: 1.5rem;
    margin: 0;

    small {
      margin-left: 0.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coin/CoinHeading.vue